import React, { useState } from 'react';
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { AuthAPI } from '../lib/api';
import { Button } from './ui/button';
import { Input } from './ui/input';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription,
} from './ui/dialog';

const ForgotPasswordDialog = ({ trigger }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await AuthAPI.forgotPassword(email.trim());
      setSent(true);
    } finally { setBusy(false); }
  };

  const close = () => {
    setOpen(false);
    setTimeout(() => { setSent(false); setEmail(''); }, 300);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setTimeout(() => { setSent(false); setEmail(''); }, 300); }}>
      <DialogTrigger asChild>
        {trigger || (
          <button type="button" data-testid="forgot-password-link" className="text-xs text-[#1F4D3F] hover:underline">
            Mot de passe oublié ?
          </button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Mail className="w-5 h-5 text-[#1F4D3F]" /> Mot de passe oublié
          </DialogTitle>
          <DialogDescription>
            Entrez votre email pour recevoir un lien sécurisé de réinitialisation.
          </DialogDescription>
        </DialogHeader>
        {sent ? (
          <div className="text-center py-4">
            <div className="w-14 h-14 rounded-full bg-emerald-50 mx-auto flex items-center justify-center mb-3">
              <CheckCircle2 className="w-7 h-7 text-emerald-600" />
            </div>
            <h3 className="font-medium text-[#2D2A26] mb-1">Lien envoyé</h3>
            <p className="text-sm text-[#7A6F5C] mb-4">
              Si un compte existe pour <strong>{email}</strong>, un lien de réinitialisation vous a été envoyé.
              Vérifiez votre boîte mail (et les spams).
            </p>
            <Button onClick={close} className="bg-[#1F4D3F] hover:bg-[#173B30] text-white" data-testid="forgot-password-close">
              <ArrowLeft className="w-4 h-4 mr-2" /> Retour à la connexion
            </Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3 pt-2">
            <p className="text-sm text-[#7A6F5C]">
              Entrez l'adresse email associée à votre compte. Nous vous enverrons un lien sécurisé pour réinitialiser votre mot de passe.
            </p>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com" required data-testid="forgot-password-email" autoFocus />
            <Button type="submit" disabled={busy} className="w-full bg-[#1F4D3F] hover:bg-[#173B30] text-white" data-testid="forgot-password-submit">
              {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Mail className="w-4 h-4 mr-2" />}
              Recevoir le lien
            </Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ForgotPasswordDialog;
